import React from 'react';
import { getDate } from '../../../../functions/hreadableDate';

const ClockSevenDaysRange = (props) => {
    const fromDate = new Date(props.current.getTime() - (7 * 24 * 60 * 60 * 1000));
    const toDate = new Date(props.current.getTime());   

    return (
        <span>{getDate(fromDate)} a {getDate(toDate)}</span>
    );
};

export default ClockSevenDaysRange;